module.exports = __webpack_public_path__ + "media/images/logo-a6cc975c371099815a1fc65a104c0eac.png";